import { getCookies, setCookie, deleteCookie, getCookie } from 'cookies-next';

class Cookies {
  get(...args) {
    const cookieString = getCookie(...args);

    if (!cookieString) {
      return cookieString;
    }

    try {
      const cookie = JSON.parse(cookieString);
      return cookie;
    } catch (error) {
      return cookieString;
    }
  }

  getAll() {
    const allCookies = getCookies();

    return {
      ...allCookies,
      remove: deleteCookie,
    };
  }

  set(...args) {
    return setCookie(...args);
  }

  remove(...args) {
    return deleteCookie(...args);
  }
}

export default Cookies;
